<template>
	<GFormGroup
		v-bind="{
			append,
			prepend,
			validFeedback,
			invalidFeedback,
			tooltipFeedback,
			description,
			wrapperClasses,
			class: computedClasses,
		}">
		<template #label>
			<slot name="label">
				<label v-if="label" :for="safeId" :class="labelClasses">
					{{ label }}
				</label>
			</slot>
		</template>

		<template #input>
			<multiselect
				v-model="state"
				v-bind="$attrs"
				v-on="$listeners"
				label="label"
				:options="options"
				:showLabels="false"
				:placeholder="placeholder"
				autocomplete="off"
				@select="onSelect" />
			<input type="hidden" v-bind="$attrs" :value="state != null ? state.value : null" />
		</template>

		<template v-for="slot in $options.slots" #[slot]>
			<slot :name="slot"></slot>
		</template>
	</GFormGroup>
</template>

<script>
	import * as allFormMixins from '../GComponentsLibraries/JsFiles/form-mixins';
	const mixins = Object.values(allFormMixins);
	import { selectProps as props } from '../GComponentsLibraries/JsFiles/form-props';
	import GFormGroup from '../GComponentsLibraries/VueFiles/GFormGroup';
	import Multiselect from 'vue-multiselect';
	import 'vue-multiselect/dist/vue-multiselect.min.css';

	export default {
		name: 'GSelect',
		inheritAttrs: false,
		components: { GFormGroup, Multiselect },
		slots: [
			'prepend',
			'prepend-content',
			'append-content',
			'append',
			'label-after-input',
			'valid-feedback',
			'invalid-feedback',
			'description',
		],
		mixins,
		props,
		// Html props: disabled, required don't use multiple
		// {
		//   validFeedback: String,
		//   invalidFeedback: String,
		//   tooltipFeedback: Boolean,
		//   description: String,

		//   append: String,
		//   prepend: String,

		//   label: String,
		//   wasValidated: Boolean,
		//   isValid: {
		//     type: [Boolean, Function],
		//     default: null
		//   },
		//   addInputClasses: [String, Array, Object],
		//   addLabelClasses: [String, Array, Object],

		//   horizontal: [Boolean, Object],
		//   size: {
		//     type: String,
		//     validator: str => ['','sm','lg'].includes(str)
		//   },
		//   addWrapperClasses: [String, Array, Object],

		//   options: Array,
		//   value: [String, Number, Boolean, Array],
		//   plaintext: Boolean,
		//   placeholder: String,
		//   custom: Boolean
		// },
		data() {
			return {
				state: this.value || null,
			};
		},
		//watchValue mixin
		watch: {
			/**
			 * Search in options for the value.
			 * You cannot set directly the value, multiselect cannot find an existing value.
			 */
			options(newValue) {
				if (newValue === null) {
					this.state = null;
				}

				const option = newValue.find(option => option.value === this.value);

				this.state = option ? option : [];
			},
			value: {
				immediate: true,
				handler(newValue) {
					const option = this.options.find(option => option.value === newValue);

					this.state = option ? option : newValue;
				},
			},
		},
		computed: {
			// classesComputedProps mixin
			// haveCustomSize () {
			//   return ['sm','lg'].includes(this.size)
			// },
			computedClasses() {
				return [
					'form-group',
					{
						'was-validated': this.wasValidated,
						'form-row': this.isHorizontal,
						required: this.$attrs.required === '',
					},
				];
			},
			// labelClasses () {
			//   return [
			//     this.addLabelClasses,
			//     {
			//       'col-form-label': this.isHorizontal,
			//       [this.horizontal.label || 'col-sm-3']: this.isHorizontal,
			//       [`col-form-label-${this.size}`]: this.haveCustomSize,
			//     }
			//   ]
			// },
			customSizeClass() {
				if (this.haveCustomSize && !this.haveWrapper) {
					return `${this.custom ? 'custom-select' : 'form-control'}-${this.size}`;
				}
			},
			inputClass() {
				const standardClass = `form-control${this.plaintext ? '-plaintext' : ''}`;
				return this.custom ? 'custom-select' : standardClass;
			},
			// inputClasses () {
			//   return [
			//     this.inputClass || `form-control${this.plaintext ? '-plaintext' : ''}`,
			//     this.validationClass,
			//     this.addInputClasses,
			//     this.customSizeClass
			//   ]
			// }

			// validationComputedProps mixin
			// computedIsValid () {
			//   if (typeof this.isValid === 'function') {
			//     return this.isValid(this.state)
			//   }
			//   return this.isValid
			// },
			// validationClass () {
			//   if (typeof this.computedIsValid === 'boolean') {
			//     return this.computedIsValid ? 'is-valid' : 'is-invalid'
			//   }
			// },

			//wrapperComputedProps mixin
			// isHorizontal () {
			//   return Boolean(this.horizontal)
			// },
			// haveInputGroup () {
			//   return Boolean(
			//     this.tooltipFeedback ||
			//     this.append ||
			//     this.prepend ||
			//     this.$slots.append ||
			//     this.$slots.prepend ||
			//     this.$slots['append-content'] ||
			//     this.$slots['prepend-content']
			//   )
			// },
			// haveWrapper () {
			//   return this.haveInputGroup || Boolean(this.addWrapperClasses || this.isHorizontal)
			// },
			// wrapperClasses () {
			//   if (this.haveWrapper) {
			//     return [
			//       this.addWrapperClasses,
			//       {
			//         [this.horizontal.input || 'col-sm-9'] : this.isHorizontal,
			//         'input-group' : this.haveInputGroup,
			//         [`input-group-${this.size}`]: this.haveCustomSize
			//       }
			//     ]
			//   }
			// }
		},

		methods: {
			onSelect(newVal) {
				this.$emit('update:value', newVal);
			},
			reset() {
				this.state = [];
			},
		},
	};
</script>

<style>
	.multiselect__tags {
		padding: 3px 40px 0 8px;
		min-height: 35px;
		height: 35px;
		border-color: #d8dbe0;
	}

	.multiselect__select {
		height: 35px;
		padding: 0 0;
	}

	.multiselect__single {
		margin-top: 2px;
	}

	.form-group.required label:after {
		content: '*';
		color: red;
	}
</style>
